const CLOSE = 'CLOSE';
const TOGGLE = 'TOGGLE';

export {
  CLOSE,
  TOGGLE,
};
